export default __webpack_public_path__ + "static/media/cp_geo_sy.b86ca545.svg";